import { IDevice } from "ua-parser-js";

export const getDeviceType = (device: IDevice | undefined, userAgentString?: string): string => {
  const userAgent = (userAgentString ?? navigator.userAgent).toLowerCase();

  if (device?.type) return device.type;

  if (/mobile|iphone|ipod|android.*mobile/.test(userAgent)) {
    return "mobile";
  } else if (/ipad|tablet|android(?!.*mobile)/.test(userAgent)) {
    return "tablet";
  } else {
    return "desktop";
  }
};
